import Loader from 'carbon-react/lib/components/loader';
import styled from 'styled-components';

const CustomSpinner = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

interface SpinnerProps {
  size?: 'small' | 'medium' | 'large';
  text?: string;
}

const Spinner = ({ size = 'large', text }: SpinnerProps) => {
  return (
    <CustomSpinner>
      <span>{text || 'Loading...'}</span>
      <Loader isActive size={size} />
    </CustomSpinner>
  );
};

export default Spinner;
